import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {WelcomeComponent} from './welcome/welcome.component';
import {ComponentsModule} from '../components/components.module';
import {UsersComponent} from './users/users.component';
import {UserDetailsComponent} from './user-details/user-details.component';
import {AppRoutingModule} from '../app-routing.module';
import {EditUserDetailsComponent} from './edit-user-details/edit-user-details.component';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {CreateUserComponent} from './create-user/create-user.component';
import {EntitiesComponent} from './entities/entities.component';
import {NewEntityComponent} from './new-entity/new-entity.component';
import {NgbRatingModule} from '@ng-bootstrap/ng-bootstrap';
import {CreateCategoryComponent} from './create-category/create-category.component';
import {SingleEntityComponent} from './single-entity/single-entity.component';
import {CategoriesComponent} from './categories/categories.component';
import {SingleCategoryComponent} from './single-category/single-category.component';
import {EditCategoryComponent} from './edit-category/edit-category.component';
import {EditEntityComponent} from './edit-entity/edit-entity.component';
import {ReviewEntityComponent} from './review-entity/review-entity.component';
import {ReviewUsersComponent} from './review-users/review-users.component';
import {AngularEditorModule} from '@kolkov/angular-editor';
import {HomeComponent} from './home/home.component';
import {ChartModule} from 'primeng/chart';
import {NewsComponent} from './news/news.component';
import {SingleNewsComponent} from './single-news/single-news.component';
import {CreateArticleComponent} from './create-article/create-article.component';
import {TestComponent} from './test/test.component';
import {SuggestionsComponent} from './suggestions/suggestions.component';
import {RatingCategoriesComponent} from './rating-categories/rating-categories.component';
import {CreateRatingCategoriesComponent} from './create-rating-categories/create-rating-categories.component';
import {ImageCropperComponent} from 'ngx-image-cropper';
import {EditRatingCategoryComponent} from './edit-rating-category/edit-rating-category.component';
import {LayoutComponent} from '../components/layout/layout.component';
import {NftCollectionComponent} from './nft-collection/nft-collection.component';
import {NftAddComponent} from './nft-add/nft-add.component';
import {NftCreateCollectionComponent} from './nft-create-collection/nft-create-collection.component';
import {NftSingleCollectionComponent} from './nft-single-collection/nft-single-collection.component';
import {BannersComponent} from './banners/banners.component';
import {MatSelectModule} from '@angular/material/select';
import {MatButtonToggleModule} from '@angular/material/button-toggle';
import {MatButtonModule} from '@angular/material/button';
import {CheckboxModule} from 'primeng/checkbox';
import {NgxPaginationModule} from 'ngx-pagination';
import {PageHeaderComponent} from './new-entity/page-header/page-header.component';
import {MatChipsModule} from '@angular/material/chips';
import {MatIconModule} from '@angular/material/icon';
import {MatCardModule} from '@angular/material/card';
import {MatStepperModule} from '@angular/material/stepper';
import {MatTabsModule} from '@angular/material/tabs';
import {PodcastsComponent} from './podcasts/podcasts.component';
import {QuotesComponent} from './quotes/quotes.component';
import {AddQuoteComponent} from './quotes/add-quote/add-quote.component';
import {NgxSkeletonLoaderModule} from 'ngx-skeleton-loader';
import {SurveysComponent} from './surveys/surveys.component';
import {AddSurveyComponent} from './surveys/add-survey/add-survey.component';
import {ProgressbarModule} from 'ngx-bootstrap/progressbar';
import { UserDetailsSkeletonsComponent } from './user-details/components/skeletons/user-details-skeletons/user-details-skeletons.component';
import {CommonComponentModule} from '../modules/common-component/common-component.module';
import { IconsComponent } from './icons/icons.component';
import {SuperCategoriesComponent} from './super-categories/super-categories.component';
import {NgSelectModule} from '@ng-select/ng-select';
import {CoreModule} from '../core/core.module';
import {TooltipModule} from 'ngx-bootstrap/tooltip';
import {MarketplaceBooksComponent} from './marketplace-books/marketplace-books.component';
import {MarketplaceProjectsComponent} from './marketplace-projects/marketplace-projects.component';
import {MarketplaceProjectApplicationsComponent} from './marketplace-project-applications/marketplace-project-applications.component';
import {UserFundingRecordsComponent} from './user-funding-records/user-funding-records.component';
import {TwitterGoldenListComponent} from './twitter-golden-list/twitter-golden-list.component';
import {TwitterPostsDashboardComponent} from './twitter-posts-dashboard/twitter-posts-dashboard.component';
import {TwitterWebhookRequestsComponent} from './twitter-webhook-requests/twitter-webhook-requests.component';
import {TwitterSessionComponent} from './twitter-session/twitter-session.component';
import {ImportDataModalComponent} from '../shared/import-data-modal/import-data-modal.component';
import { GoldenHandleModalComponent } from './shared/golden-handle-modal/golden-handle-modal.component';
import {EcommerceCategoriesComponent} from './ecommerce-categories/ecommerce-categories.component';
import {EcommerceProductsComponent} from './ecommerce-products/ecommerce-products.component';
import {EcommerceOrdersComponent} from './ecommerce-orders/ecommerce-orders.component';

@NgModule({
  declarations: [
    WelcomeComponent,
    UsersComponent,
    UserDetailsComponent,
    EditUserDetailsComponent,
    CreateUserComponent,
    EntitiesComponent,
    NewEntityComponent,
    CreateCategoryComponent,
    SingleEntityComponent,
    CategoriesComponent,
    SingleCategoryComponent,
    EditCategoryComponent,
    EditEntityComponent,
    ReviewEntityComponent,
    ReviewUsersComponent,
    HomeComponent,
    NewsComponent,
    SingleNewsComponent,
    CreateArticleComponent,
    TestComponent,
    SuggestionsComponent,
    RatingCategoriesComponent,
    CreateRatingCategoriesComponent,
    EditRatingCategoryComponent,
    LayoutComponent,
    NftCollectionComponent,
    NftAddComponent,
    NftCreateCollectionComponent,
    NftSingleCollectionComponent,
    BannersComponent,
    PageHeaderComponent,
    PodcastsComponent,
    QuotesComponent,
    AddQuoteComponent,
    SurveysComponent,
    AddSurveyComponent,
    UserDetailsSkeletonsComponent,
    IconsComponent,
    SuperCategoriesComponent,
    MarketplaceBooksComponent,
    MarketplaceProjectsComponent,
    MarketplaceProjectApplicationsComponent,
    UserFundingRecordsComponent,
    TwitterGoldenListComponent,
    TwitterPostsDashboardComponent,
    TwitterWebhookRequestsComponent,
    TwitterSessionComponent,
    GoldenHandleModalComponent,
    EcommerceCategoriesComponent,
    EcommerceProductsComponent,
    EcommerceOrdersComponent
  ],
  imports: [
    CommonModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    ComponentsModule,
    ImageCropperComponent,
    NgbRatingModule,
    AngularEditorModule,
    ChartModule,
    MatSelectModule,
    MatButtonToggleModule,
    MatButtonModule,
    CheckboxModule,
    NgxPaginationModule,
    MatChipsModule,
    MatIconModule,
    MatCardModule,
    MatStepperModule,
    MatTabsModule,
    NgxSkeletonLoaderModule,
    ProgressbarModule,
    CommonComponentModule,
    NgSelectModule,
    CoreModule,
    TooltipModule,
    ImportDataModalComponent,
  ]
})
export class DashboardModule {
}
